import { render, staticRenderFns } from "./SecurityLogo.vue?vue&type=template&id=674b9c80&scoped=true&"
import script from "./SecurityLogo.vue?vue&type=script&lang=js&"
export * from "./SecurityLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b9c80",
  null
  
)

export default component.exports